<template>
  <section id="admin-filter">
    <h4>Tariff Merge filter - {{ propTitle }}</h4>
    <div class="form-group">
      <label class="form-label">Service Provider</label>
      <autocomplete
        :dataset="partySearchResults"
        title="Service Provider"
        placeHolder="Type to search"
        :initVal="entity.serviceProvider"
        v-on:changing="data => partySearchText = data"
        :fnFormatText="displayParty"
        :fnSelectValue="displayParty"
        v-on:selection-made="selectServiceProvider"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label for="tm-desc" class="form-label">Description</label>
      <input type="text" class="form-control" id="tm-desc" v-model="entity.description"/>
    </div>
    <div class="form-group">
      <label for="tm-sc" class="form-label">Service Contract</label>
      <input type="text" class="form-control" id="tm-sc" v-model="entity.serviceContract"/>
    </div>
    <div class="form-group" v-for="d in optionsDropdowns">
      <label :for="'tm-' + d.label" class="form-label">{{ d.label }}</label>
      <select class="form-control" :id="'tm-' + d.label" v-model="entity[d.prop]">
        <option value=""></option>
        <option v-for="(opt, i) in mergeSystemOptions[d.prop]" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <hr>
    <div class="form-group">
      <label for="tm-selection" class="form-label">Search Results</label>
      <select class="form-control" id="tm-selection" v-model="selection">
        <option value=""></option>
        <option v-for="(opt, i) in searchResults" :value="opt">{{ makeDisplay(opt) }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-default sq"  @click="emitSearch">
        Search <pulse-loader v-show="loading" :size="'3px'" :style="{ display: 'inline' }"></pulse-loader>
      </div>
      <div class="btn btn-primary sq" @click="doSelection">
        Select
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import HelperMixin from '../../admin/mixins/Helpers'
  import FilterMixin from '../../admin/mixins/FilterMixin'
  import Autocomplete from '../../helpers/AutoComplete'
  import API from '../../../api/endpoints'
  import PulseLoader from '../../helpers/PulseLoader.vue'
  import event from '../../../event'
  export default {
    name: 'TariffMergeFilter',
    mixins: [ HelperMixin, FilterMixin ],
    components: {
      Autocomplete,
      PulseLoader
    },
    data () {
      return {
        loading: false,
        optionsDropdowns: [
          {
            prop: 'densityType',
            label: 'Minimum Density Type'
          },
          {
            prop: 'mode',
            label: 'Mode'
          },
          {
            prop: 'breakpointsPer',
            label: 'Breakpoints Per'
          },
          {
            prop: 'ratesPer',
            label: 'Rates Per'
          },
          {
            prop: 'distanceType',
            label: 'Distance Type'
          }
        ],
        entity: {
          serviceProvider: null,
          description: '',
          serviceContract: '',
          densityType: '',
          mode: '',
          breakpointsPer: '',
          ratesPer: '',
          distanceType: ''
        },
        searchResults: [],
        selection: null
      }
    },
    computed: {
      lookupProfileType () {
        return this.initData.lookupProfileType || null
      },
      mergeProperty () {
        return this.initData.prop || null
      },
      propTitle () {
        return this.initData.prop ? this.deCamel(this.initData.prop) : ''
      },
      mergeSystemOptions () {
        return {
          densityType: this.sortedOptions('UNIT_TYPE'),
          mode: this.sortedOptions('MODE'),
          breakpointsPer: this.sortedOptions('BREAKPOINT_UNIT'),
          ratesPer: this.sortedOptions('BREAKPOINT_UNIT'),
          distanceType: this.sortedOptions('DISTANCE_TYPE')
        }
      },
      requestBody () {
        let search = {
          ...this.entity,
          serviceProvider: this.entity.serviceProvider !== null && this.entity.serviceProvider.hasOwnProperty('id') ? this.entity.serviceProvider.id : null
        }
        let refined = {
          lookupProfileType: this.lookupProfileType
        }
        for (let prop in search) {
          if (search[prop] !== null && search[prop] !== '') {
            refined[prop] = search[prop]
          }
        }
        return refined
      }
    },
    watch: {
      lookupProfileType (newVal, oldVal) {
        this.entity.lookupProfileType = newVal
        if (newVal !== oldVal) {
          this.searchResults = []
          this.selection = null
        }
      }
    },
    methods: {
      emitSearch () {
        this.doSearch()
      },
      makeDisplay (val) {
        return val !== null && val.hasOwnProperty('id') ? `${val.description}, ${val.serviceProvider.name} - ${val.serviceProvider.code}, ${val.lookupProfileType.name}` : ''
      },
      doSelection () {
        if (this.selection !== null && this.selection.hasOwnProperty('id')) {
          event.$emit(this.event, { selection: this.selection, prop: this.mergeProperty })
          this.close()
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure you have made a selection' })
        }
      },
      doSearch () {
        this.loading = true
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('lookup-profile'), {
          params: this.requestBody,
          headers: { 'X-Lazy-Fetch': '0' }
        }).then(({data}) => {
          this.searchResults = data
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.loading = false
        })
      },
      selectServiceProvider (p) {
        this.entity.serviceProvider = p
        this.partySearchText = ''
        this.partySearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/tariffmerge/components/TariffMergeFilter.vue